import { Band } from '../../../foundation/acceso-parts';

/**
 * docs/decisions/2026-10-28-tpv-sin-conexion.md · a session of another restaurant on a tablet that keeps entries of its
 * own restaurant: the band of the login door's family, above the Panel, until someone of that restaurant signs in here
 * and uploads them.
 */
export function TpvOtherRestaurantBand() {
  return <div className="runtime-tablet-band">
    <Band glyph="tablet" role="status" tone="caution">Hay operaciones sin subir de otro local en esta tablet: entra en ese local para subirlas.</Band>
  </div>;
}
